// extracted by mini-css-extract-plugin
export default {"callToAction":"call-to-action-wrapper_callToAction__2voqm"};